import { ISnotrRoute } from '..';

export default [
  {
    path: '/advanced-paychecks/',
    component: () => import('@/pages/AdvancedPaychecks/advanced-paychecks.vue'),
    children: [
      {
        path: '',
        name: 'AdvancedPaychecks',
        meta: {
          title: 'TabTitle.paychecks',
          applicationMode: 'PaycheckMode',
        },
        component: () => import('@/pages/paychecks.vue'),
        props: () => ({
          advancedPaycheckMode: true,
        }),
      },
      {
        path: 'new',
        name: 'AdvancedPaychecksNew',
        meta: {
          title: 'TabTitle.newPaycheck',
          applicationMode: 'PaycheckMode',
        },
        component: () => import('@/pages/paychecks-new.vue'),
        props: route => ({
          workRelationId: route.query.workRelationId,
          subUnitId: route.query.subUnitId,
          periodId: route.query.periodId,
          advancedPaycheckMode: true,
        }),
      },
      {
        path: 'edit/:id',
        name: 'AdvancedPaychecksEdit',
        meta: {
          title: 'TabTitle.editPaycheck',
          applicationMode: 'PaycheckMode',
        },
        component: () => import('@/pages/paychecks-edit.vue'),
        props: route => ({
          paycheckId: route.params.id,
          advancedPaycheckMode: true,
        }),
      },
    ],
  },
] as ISnotrRoute[];
